import { ITradingCardClasses } from "./TradingCard";

export default <ITradingCardClasses>{
  base: "glass__bg transition duration-700 ease-in-out md:cursor-pointer after:skew-y-3 hover:after:skew-y-12 rounded-lg px-6 sm:min-w-[260px] max-w-[360px] h-[130px] tb:h-[105px] flex items-center justify-start w-full tb:max-w-none z-10 relative",
  title: "inter pb-2 text-[0.9rem] sm:text-[0.8rem] font-medium",
  heading: "jaka text-white !text-[2rem] font-bold sm:!text-[1.85rem]",
  icon: "flex items-center justify-center rounded-full w-20 tb:w-14 h-20 tb:h-14 sm:p-2 p-3 rounded-full bg-black sm:p-[0.8rem]"
};
